import { Inject, Injectable } from '@angular/core';
import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { APP_CONFIG } from '../config';
import { ReservationV2DataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { IHotelReservationV2 } from '../interfaces/HotelReservationV2/IHotelReservation-IV2';
import { CookieService } from 'ngx-cookie-service';
import { ICommunicationPreferences } from '../interfaces/HotelReservationV2/ICommunicationPreferences';

const CLASS_NAME = 'ReservationV2Dao';

@Injectable()
export class ReservationV2Dao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.reservationV2DAO, new DefaultRetryHandler(), new ReservationV2DataValidator(), log, cookieService);
  }

  get(reservationId: string, lastName: string): Observable<any> {
    const url = `${this.daoConfig.url}/${reservationId}?lastName=${lastName}`;
    return super.doGet(url);
  }

  put(reservationId: string, reservationData: IHotelReservationV2): Observable<any> {
    const url = `${this.daoConfig.url}/${reservationId}`;
    return super.doPut(url, reservationData);
  }

  patch(reservationId: string, lastName: string, communicationPreferences: ICommunicationPreferences): Observable<any> {
    const url = `${this.daoConfig.url}/${reservationId}?reservationStatus=CANCEL&lastName=${lastName}`;
    return super.doPatch(url, communicationPreferences, this.buildPatchHeaders());
  }

  buildPatchHeaders(): { [key: string]: string; } {
    return ({ 'content-type': 'application/json' });
  }

};



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/reservation-v2.dao.ts